import { Prop, Watch, tlISODateTimeToLocalNoSecondsString, RightHelper, BaseTLDetailComponent, TagService, MGMTCertificateService, MGMTCertificateFilter, AxiosResponse, ObjectTypesHelper, tlStore } from "../../../Infrastructure/CorBase/CoreBase";
import {  ServicesFactory } from "../../../Infrastructure/ServicesFactory";

export default abstract class CertificateDetailBase extends BaseTLDetailComponent {

	certificateService: MGMTCertificateService = new MGMTCertificateService();

	isEditDetail = false;
	allCertificates = [];
	formIsInEditModeGlobal = false;
	fileContent: File | null = null;
	fileContentGlobal: File | null = null;
	isUpdate = false;
	isUpdateGlobal = false;
	returnRoute: string = "CertificateDetail";

	isDeleteTenant = true;

	goToEditGlobal() {
		this.formIsInEditModeGlobal = true;
	}

	rightTenant() {
		return RightHelper.currentUserHasRight('COR_Setting_Tenant');
	}

	rightGlobal() {
		return RightHelper.currentUserHasRight('COR_Setting_Global') && this.isSuperUser;
	}

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	save(isTenant: boolean) {
		if (this.passwordNeed || this.passwordNeedGlobal) {
			var fileCert = this.passwordNeed ? this.fileContent : this.fileContentGlobal;
			var update = this.passwordNeed ? this.isUpdate : this.isUpdateGlobal;
			let formData: FormData = this.dataToFormData(fileCert as File, isTenant, update);       
			if (update) {
				this.certificateService.updateCertificate(1, formData).then(res => {
					this.fetchData();
				}).catch(res => {	
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errors.toString());
				});
				
            }
			else {
				this.certificateService.create( formData).then(res => {
					this.fetchData();
				}).catch(res => {
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errors.toString());
                });
            }
		}
		else {
			this.update();
			//this.doAction();
        }
	}



	addCertificate(isTenant: boolean, isUpdate: boolean) {
		var input = document.createElement('input');
		input.type = 'file';
		input.accept = '.pfx';
		
		input.onchange = (e: any) => {
			var file = e.target.files[0];
			if (isTenant) {
				this.isUpdate = isUpdate;
				this.passwordNeed = true;
				this.fileContent = file;
				this.formData.fileName = file.name;
				this.$nextTick(() => {
					document.getElementById("passwordTenant")!.focus();
				});
			}
			else {
				this.isUpdateGlobal = isUpdate;
				this.passwordNeedGlobal = true;
				this.fileContentGlobal = file;
				this.formDataGlobal.fileName = file.name;
				
				this.$nextTick(() => {
					document.getElementById("passworddGlobal")!.focus();
				});
            }
		}
		input.click();
	}

	private dataToFormData(file: File, isTenant: boolean, isUpdate: boolean ): FormData {
		let formData: FormData = new FormData();
		if (isTenant) {

			formData.append('fileContent', file);
			formData.append('password', this.formData.password);
			if (isUpdate) {
				formData.append('id', this.formData.id.toString());
				formData.append('name', this.formData.name);
			}			
			formData.append('tenantId', tlStore.state.idTenant + '');
			
		}
		else {
			formData.append('fileContent', file);
			formData.append('password', this.formDataGlobal.password);
			if (isUpdate) {
				formData.append('id', this.formDataGlobal.id.toString());
				formData.append('name', this.formDataGlobal.name);
			}
        }
		return formData;
	}	

	fields = [
		{ key: 'name', label: this.$t('certificate.name'), trans: 'certificate.name', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'dnsNames', label: this.$t('certificate.dnsNames'), trans: 'certificate.dnsNames', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'validTo', label: this.$t('certificate.date'), trans: 'certificate.date', sortable: true, class: 'text-center', optional: false, visible: true, formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
		{ key: 'tenantIdentifier', label: this.$t('certificate.identificate'), trans: 'certificate.identificate', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'tenantName', label: this.$t('certificate.tenant'), trans: 'certificate.tenant', sortable: true, class: 'text-center', optional: false, visible: true }
	];

	filters = [
		{ key: 'name', label: this.$t('certificate.name'), trans: 'certificate.name', selected: false, value: null, type: 'text' },
		{ key: 'tenantName', label: this.$t('certificate.tenant'), trans: 'certificate.tenant', selected: false, value: null, type: 'text' },
		{ key: 'tenantIdentifier', label: this.$t('certificate.identificate'), trans: 'certificate.identificate', selected: false, value: null, type: 'text' }
	];

	
	formData = {
		id: 0 as number,
		name: '' as string,
		tenantName: '' as string,
		fileName: '' as string,
		password: '' as string,
		tenantIdentifier: '' as string,
		tenantId: 0 as number,
		fileContent: null,
		validTo: '' as string,
		passwordNeed: false
	};

	formDataGlobal = {
		id: 0 as number,
		name: '' as string,
		tenantName: '' as string,
		tenantIdentifier: '' as string,
		fileName: '' as string,
		password: '' as string,
		tenantId: 0 as number,
		validTo: '' as string
	};

	idBasePreview = 0;

	goToEditBase(isTenant: boolean): void {
		if (isTenant) {
			this.formIsInEditMode = !this.formIsInEditMode;
		}
		else {
			this.formIsInEditModeGlobal = !this.formIsInEditModeGlobal;
        }
	}

	modalNameContent(): string {
		return this.$t('certificate.modalContentName') + this.formData.name;
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		this.passwordNeed = this.passwordNeedGlobal = false;
		this.formData.password = '';
		this.isUpdate = false;
		this.formData.fileName = '';		
		this.formDataGlobal.password = '';
		this.isUpdateGlobal = false;
		this.formDataGlobal.fileName = '';
		let filter: MGMTCertificateFilter = new MGMTCertificateFilter(null);
		return this.certificateService.getAllByFilter(filter);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	protected processResponse(response: AxiosResponse<any>): void {
		var tenant = response.data.filter((c: any) => c.tenantId == tlStore.state.idTenant);
		if ((tenant as []).length > 0) {
			this.formData.id = tenant[0].id;
			this.formData.name = tenant[0].name;
			this.formData.validTo = tlISODateTimeToLocalNoSecondsString(tenant[0].validTo);

		}

		var global = response.data.filter((c: any) => c.tenantId == null);
		if ((global as []).length > 0) {
			this.formDataGlobal.id = global[0].id;
			this.formDataGlobal.name = global[0].name;
			this.formDataGlobal.validTo = tlISODateTimeToLocalNoSecondsString(global[0].validTo);
		}
		this.allCertificates = response.data;
	}

	protected afterCreate(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
	}

	protected afterDelete(response: AxiosResponse<any>): void {
		if (this.isDeleteTenant) {
			this.formData.id = 0;
			this.formData.name = '';
			this.formData.validTo = '';
		}
		else {
			this.formDataGlobal.id = 0;
			this.formDataGlobal.name = '';
			this.formDataGlobal.validTo = '';
		}
		this.fetchData();
	}

	protected afterUpdate(response: AxiosResponse<any>): void {
		this.formIsInEditModeGlobal = false;
		this.fetchData();
		this.passwordNeed = this.passwordNeedGlobal = false;
	}

	vIsCorrectName: boolean = true;
	vIsCorrectPassword: boolean = true;

	vIsCorrectNameGlobal: boolean = true;
	vIsCorrectPasswordGlobal: boolean = true;

	passwordNeed: boolean = false;
	passwordNeedGlobal: boolean = false;

	validateBase(isTenant: boolean) {
		if (isTenant) {
			return !(this.vIsCorrectName && this.vIsCorrectPassword);
		}
		else {
			return !(this.vIsCorrectNameGlobal && this.vIsCorrectPasswordGlobal);
        }
	}

	isCorrectNameBase(value: any) {
		this.vIsCorrectName = value;
	}

	isCorrectPasswordBase(value: any) {
		this.vIsCorrectName = value;
	}

	isCorrectNameGlobalBase(value: any) {
		this.vIsCorrectNameGlobal = value;
	}

	isCorrectPasswordGlobalBase(value: any) {
		this.vIsCorrectNameGlobal = value;
	}

	doAction() {
		super.doCRUDActionWithInfoMessage(this.$t('certificate.messageNew').toString(), this.$t('certificate.messageEdit').toString(), this.$t('certificate.messageDelete').toString());
	}

	update() {
		if (this.formIsInEditMode) {
			delete this.formData.validTo;
			 this.certificateService.update(this.formData.id, this.formData).then(res => {
				 this.formIsInEditMode = false;
			}).catch(er => {
				this.formIsInEditMode = false;
				var error = er.data.errors.join(', ').toString();
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), error);
				this.fetchData();
			});
		}
		else {
		//	this.formIsInEditMode = true;
			delete this.formDataGlobal.validTo;
			delete this.formDataGlobal.tenantId;
			this.certificateService.update(this.formDataGlobal.id, this.formDataGlobal).then(res => {
				this.formIsInEditModeGlobal = false;
			}).catch(er => {
				var error = er.data.errors.join(', ').toString();
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), error);
				this.formIsInEditModeGlobal = false;
				this.fetchData();
			});
		}
	}

	//tohle nepouzivam
	protected updateObject(): Promise<AxiosResponse<any>> {
		if (this.formIsInEditMode) {
			delete this.formData.validTo;
			return this.certificateService.update(this.formData.id, this.formData);
		}
		else {
			this.formIsInEditMode = true;
			delete this.formDataGlobal.validTo;
			delete this.formDataGlobal.tenantId;
			return this.certificateService.update(this.formDataGlobal.id, this.formDataGlobal);
        }
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return this.certificateService.update(this.formData.id, this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		var id = this.isDeleteTenant ? this.formData.id : this.formDataGlobal.id;
		return this.certificateService.delete(id);
	}

	//@ts-ignore
	@Watch('$i18n.locale')
	changeLanguageBase(value: boolean, oldValue: boolean) {
		if (value !== oldValue) {
			this.fields = this.changeTranslate(this.fields);			
		}
	}
}
